import { Modal, Spacer, TextGroupMedium } from "@cd2/components"
import { IComponentProp } from "@cd2/tools"
import React from "react"
import { IAddressFormProps } from "./AddressForm"
import { CustomerAddressForm } from "./CustomerAddressForm"

// This is also being used by suppliers

interface IProps {
  customerId?: string
  isOpen: boolean
  heading: string
  body?: IComponentProp<typeof TextGroupMedium, "body">
  includeDefaultCheckbox?: { shipping?: boolean; billing?: boolean }
  fieldMaxLength?: number

  onCancel(): void
}

export function CustomerAddressFormModal<T extends string>({
  isOpen,
  onCancel,
  heading,
  body,
  onSubmit,
  initialData,
  actions,
  includeDefaultCheckbox,
  suggestedEmails,
  fieldMaxLength,
}: IProps & IAddressFormProps<T>) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      render={() => (
        <div>
          <TextGroupMedium heading={heading} body={body} />
          <Spacer size={16} />
          <CustomerAddressForm
            onSubmit={onSubmit}
            initialData={initialData}
            actions={actions || []}
            includeDefaultCheckbox={includeDefaultCheckbox}
            suggestedEmails={suggestedEmails}
            fieldMaxLength={fieldMaxLength}
          />
        </div>
      )}
    />
  )
}
